import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const TransporteTercerizadoUtilizacionBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const allLabels = ['Construcción', 'Automotriz', 'Servicios logísticos', 'Alimentos', 'Retail', 'Manufactura', 'Salud/Farmacéutica'];

  const transportData2023 = {
    Construcción: 12,
    Automotriz: 50,
    'Servicios logísticos': 55,
    Alimentos: 65,
    Retail: 66,
    Manufactura: 81,
    'Salud/Farmacéutica': 82,
  };


  const transportData2024 = {
    Construcción: 71,
    Automotriz: 70,
    'Servicios logísticos': 92,
    Alimentos: 74,
    Retail: 79,
    Manufactura: 68,
    'Salud/Farmacéutica': 2,
  };


  const colorMap = {
    transport2023: '#1F3D58',
    transport2024: '#476A8E',
  };

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;
  const transportValues2023 = labels.map((label) => transportData2023[label]);
  const transportValues2024 = labels.map((label) => transportData2024[label]);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Transporte tercerizado (2022)',
        data: transportValues2023,
        backgroundColor: colorMap.transport2023,
      },
      {
        label: 'Transporte tercerizado (2023)',
        data: transportValues2024,
        backgroundColor: colorMap.transport2024,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
        bottom: 20,
        left: 10,
        right: 10,
      },
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 15,
          padding: 20,
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 10,
        },
        formatter: (value) => `${value}`,
        anchor: 'end',
        align: 'end',
        offset: -5,
        clip: false,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 10,
        },
      },
      y: {
        categoryPercentage: 0.7,
        barPercentage: 0.5,
        ticks: {
          font: {
            size: 14,
          },
        },
      },
    },
  };

  const infoContent = {
    Analisis: 'En 2023, Servicios logísticos y Retail lideran en uso de transporte, reflejando una alta movilidad de mercancías. Retail y Alimentos muestran un aumento en transporte, con respecto del 2022. Construcción sigue con el menor uso de transporte, aunque muestra un ligero crecimiento. En cuanto a la utilización de recursos, Automotriz y Salud/Farmacéutica tienen la mayor eficiencia.',
    formulas: {
      transporteTercerizado: '(Número de operaciones tercerizadas / Total de operaciones de transporte) × 100',
    },
    description: 'Esta gráfica compara el porcentaje de transporte tercerizado y la utilización de contenedores en diversas industrias durante los años 2022 y 2023. Ambos indicadores evalúan la eficiencia en la logística y el transporte.',
  };
  

  return (
    <div style={{ maxWidth: '1000px', height: '480px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmulas:</strong></p>
          <p>Transporte Tercerizado: {infoContent.formulas.transporteTercerizado}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
         
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
  
};

export default TransporteTercerizadoUtilizacionBar;
